import { Component, Inject,OnInit,OnDestroy } from '@angular/core';
import { _fixedSizeVirtualScrollStrategyFactory } from '@angular/cdk/scrolling';
import {  MAT_DIALOG_DATA,  MatDialog, MatDialogRef } from '@angular/material';
import { DOCUMENT } from '@angular/platform-browser';
import {  Router } from '@angular/router';
import Popup from 'ol-popup';
import { click } from 'ol/events/condition.js';
import Select from 'ol/interaction/Select.js';
import { alertinfo, infoForFloor, getNotifybyAlert, getNearestStaff } from './home';
import { HomeService } from './home.service';
import { appsettings,  enumAlertStatus, enumAlertAckStatus, enumRequestFrom, alert_raisedon,enumCheckResidenStaff, enumAlertType, fillcolorPolygon,NewDeviceTypeDesc,DeviceTypeDesc } from '../../app-settings';
import { AlertSharedService } from '../../_services/index';
import { SharedAlertData, SharedFloorAlertData, SharedData, SharedAlertLoadData, SharedCheckAlertData, ShareInfraopenMsg, getAlertData, cancelAlert } from '../../api';
import { AlertnotificationComponent } from './alertnotification/alertnotification.component';
import { MapnotificationComponent } from './mapnotification/mapnotification.component';
import { AccesscodeComponent } from '../../accesscode/accesscode.component';
import { ApiService } from '../../api.service';
import { alerticonstyle, searchalerticonstyle, alerticonred, label_Polygon,  fillcolor_style_Home_Space,fillcolor_style_Home } from '../../map-general';
import {getDeviceDetailsReq} from '../technologyoverlay/technologyoverlay';
import { get_geojsonObject_campus, get_geojsonObject_floor, map_creation,get_VectorSource } from '../../map-general';
import { LoadBuildingSvg, maponclicked, AddBuildingLayer, ShowPopupManual, getCheckInExtent, CheckAlertByDeviceTypeId,getboxFromYpos,getDevicetype_image,convertToSvgEcllipseXCoordinate,convertToSvgEcllipseYCoordinate,calculatexycoordinates } from '../../app-general';
import { map_widthandheight, LoadFloorSvg, AddFloorLayer, ShowFloorPopupManual, groupBy, set_SharedDetails,SessionCheck,RefreshIconDetails, checkStaffData, generateAlertMessage,createVectorLayer_Campus } from '../../app-general';
import { RollbarService } from '../../rollbar';
import * as Rollbar from 'rollbar';
import { MainLayoutService } from '../../main-layout/main-layout.service';
import { SidenavComponent } from '../../main-layout/sidenav/sidenav.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfirmMessageComponent } from '../../confirm-message/confirm-message.component';
import { HomeHeaderComponent } from '../home/home-header/home-header.component';
import { CloseLocationChangeSocket } from '../../app.component';
import OlPoint from 'ol/geom/Point'
import OlFeature from 'ol/Feature';
import OlVectorLayer from 'ol/layer/Vector';
import OlVectorSource from 'ol/source/Vector';
import Polygon from 'ol/geom/Polygon';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit,OnDestroy {
  SharedFloorAlertDetails: SharedFloorAlertData;
  SharedDetails: SharedData;
  SharedAlertLoadDetails: SharedAlertLoadData;
  CheckAlertData: SharedCheckAlertData;
  ShareInfraopenDetails : ShareInfraopenMsg;
  Isinfra = 0;

  CampusImageURL = "";
  BuildingImageURL = "";
  FloorImageURL = "";
  ImageUrl = "";
  ImageWidth = "";
  ImageHeight = "";
  SvgImageUrl = "";
  SvgInfo = null;
  SpaceInfo = null;
  FloorInfo = null;
  SiteId = "1";
  public MCampusId = 0;
  public MBuildingId = 0;
  public MFloorId = 0;
  public MSubZoneId = 0;
  AlertId = "";
  ResidentId = "";
  AlertStatus = 0;
  StaffAlert = 0;
  InfraAlert = 0;
  MMapDataDetails = "0_0_0_0_0_0_0_0_0";
  Map_array_length = 8;
  Map_image_path = 'assets/images/map/';
  CampusFulldetails = null;
  imgheight = 0;
  imgwidth = 0;

  alertData: alertinfo[];
  infoForFloorData: infoForFloor[];
  alertinfofromshared: SharedAlertData[];
  Imgurl: string = appsettings.IMAGE_FOLDER;
  residentImgUrl: string = appsettings.RESIDENT_FOLDER;
  staffImgUrl: string = appsettings.STAFF_FOLDER;
  alertinfo;
  Residents;
  notifiedinfo;
  CZoomLevel;
  CRotateLevel
  pollingData: any;
  TranslateX;
  TranslateY; 
  private _onDestroy: Subject<void> = new Subject<void>();
  constructor(private router: Router, private dialog: MatDialog, @Inject(DOCUMENT) private document: any, @Inject(MAT_DIALOG_DATA) public data: any,
  private homeService: HomeService, private alertSharedService: AlertSharedService, private apiService: ApiService,
  @Inject(RollbarService) private rollbar: Rollbar,public mainLayoutService: MainLayoutService,
public thisDialogRef: MatDialogRef<HomeComponent>) { 
    
      try
      {        
        CloseLocationChangeSocket();
        homeService.SubscribeforLocationChangeData();          
      }
      catch (err) {
        throw new Error('home.component.ts' + ' - constructor() - ' + err.message);
      }
  }

  ngOnInit() {                                     
    try {
      this.alertSharedService.currentSharedAlert().pipe(takeUntil(this._onDestroy)).subscribe((SharedAlertDetails: SharedAlertData[]) => {
      this.alertinfofromshared = SharedAlertDetails;
      this.alertinfo = SharedAlertDetails;
	    });
      this.alertSharedService.currentsharedInfraAlert().pipe(takeUntil(this._onDestroy)).subscribe((ShareInfraopenDetails: any) => {
        this.ShareInfraopenDetails = ShareInfraopenDetails;
        if (this.ShareInfraopenDetails != undefined) {
          this.Isinfra = this.ShareInfraopenDetails.IsfraOpen;
        }
      });
      this.alertSharedService.currentShared().pipe(takeUntil(this._onDestroy)).subscribe((SharedDetails: SharedData) => { this.SharedDetails = SharedDetails });
      this.alertSharedService.currentsharedFloorAlert().pipe(takeUntil(this._onDestroy)).subscribe((SharedFloorAlertDetails: SharedFloorAlertData) => { this.SharedFloorAlertDetails = SharedFloorAlertDetails });
      
      this.getStaffById();  
    }
    catch (err) {
      throw new Error('home.component.ts' + ' - ngOnInit() - ' + err.message);
    }
  }

  getStaffById()
  {  
    checkStaffData(this.apiService,this.alertSharedService);    
  }

  selectFloorInfoFull(floorInfo,bNeedBuildingOutline,bNeedApprOutline) {
    try {
      this.apiService.getDeviceDetails(floorInfo).pipe(takeUntil(this._onDestroy))
        .subscribe((infoForFloordetails: any[]) => {
          this.infoForFloorData = infoForFloordetails["apiReturn"];
          this.FloorInfo = this.infoForFloorData;
          this.DrawMapCall(bNeedBuildingOutline,bNeedApprOutline);
        });
    }
    catch (err) {
      throw new Error('home.component.ts' + ' - selectFloorInfoFull() - ' + err.message);
    }
  }
  Chk_alertnotification = 0;
  showalertnotification() {
    try {
      if (!SessionCheck(this.router)) {
        return;
      }            
      let sel_CampusId = this.document.getElementById('spn_CampusId').innerHTML;
      let sel_BuildingId = this.document.getElementById('spn_BuildingId').innerHTML;
      let sel_FloorId = this.document.getElementById('spn_FloorId').innerHTML;
      let sel_RoomId = this.document.getElementById('spn_RoomId').innerHTML;
      let sel_AlertId = this.document.getElementById('spn_AlertId').innerHTML;
      var sel_AlertType = this.document.getElementById('spn_AlertType').innerHTML;
      var sel_AlertResStaff = this.document.getElementById('spn_AlertResStaff').innerHTML;
      var sel_DeviceType = this.document.getElementById('spn_Devicetype').innerHTML;
      var sel_DeviceSubType = this.document.getElementById('spn_DeviceSubtype').innerHTML;
      var sel_LocationType = this.document.getElementById('spn_Locationtype').innerHTML;
      var sel_Staffdata;
      var sel_NearestStaffdata;
     
      this.notifiedinfo = this.alertinfo.filter(function(e)
      {
        return e.AlertId == parseInt(sel_AlertId)
      });          
      if (this.Chk_alertnotification == 0) {
        this.Chk_alertnotification = 1;
        var Notifyitem : getNotifybyAlert = 
        { 
          siteId: this.SiteId,
          authKey: localStorage.getItem("Authkey"),
          alertType: parseInt(sel_AlertType), 
          alertId: parseInt(sel_AlertId), 
          isResident: parseInt(sel_AlertResStaff), 
          deviceSubType: parseInt(sel_DeviceSubType), 
          deviceType: parseInt(sel_DeviceType),
          nLocationZone: parseInt(sel_LocationType)
        };        
        this.homeService.getNotificationByAlert(Notifyitem).pipe(takeUntil(this._onDestroy))
          .subscribe((Staffdata: any[]) => {            
            sel_Staffdata = Staffdata["apiReturn"];
            var NearestStaffitem : getNearestStaff = 
            { 
              siteId: this.SiteId, 
              authKey: localStorage.getItem("Authkey"), 
              roomId: parseInt(sel_RoomId), 
              floorId: parseInt(sel_FloorId) 
            }
            this.homeService.getNearestStaffForAlert(NearestStaffitem).pipe(takeUntil(this._onDestroy))
              .subscribe((NearestStaffdata: any[]) => {               
                sel_NearestStaffdata = NearestStaffdata;
                var NotifyData = {
                  AlertData: this.notifiedinfo,
                  CampusId: parseInt(sel_CampusId),
                  BuildingId: parseInt(sel_BuildingId),
                  FloorId: parseInt(sel_FloorId),
                  RoomId: parseInt(sel_RoomId),
                  AlertId: parseInt(sel_AlertId),
                  AlertType: parseInt(sel_AlertType),
                  AlertResStaff: parseInt(sel_AlertResStaff),
                  DeviceType: parseInt(sel_DeviceType),
                  DeviceSubType: parseInt(sel_DeviceSubType),
                  LocationType: parseInt(sel_LocationType),
                  Staffdata: sel_Staffdata,
                  NearestStaffdata: sel_NearestStaffdata
                }

                let dialogRef = this.dialog.open(AlertnotificationComponent, {
                  disableClose: true,
                  width: '450px',
                  height: 'auto',
                  panelClass: 'myapp-no-padding-dialog',
                  autoFocus: false,
                  data: NotifyData
                });

                dialogRef.afterClosed().subscribe(result => {
                  if (result == "CanceledAlert") {
                  }
                  this.Chk_alertnotification = 0;
                });
              });
          });
      }
    }
    catch (err) {
      throw new Error('home.component.ts' + ' - showalertnotification() - ' + err.message);
    }
  }
  Chk_mapnotification = 0;
  public showmapnotification() {
    try {
      if (!SessionCheck(this.router)) {
        return;
      }      
      let sel_CampusId = this.document.getElementById('spn_MapCampusId').innerHTML;
      let sel_BuildingId = this.document.getElementById('spn_MapBuildingId').innerHTML;
      let sel_FloorId = this.document.getElementById('spn_MapFloorId').innerHTML;
      let sel_RoomId = this.document.getElementById('spn_MapRoomId').innerHTML;
      let sel_AlertId = this.document.getElementById('spn_MapAlertId').innerHTML;
      var sel_AlertType = this.document.getElementById('spn_MapAlertType').innerHTML;
      var sel_AlertResStaff = this.document.getElementById('spn_MapAlertResStaff').innerHTML;
      var sel_DeviceType = this.document.getElementById('spn_MapDevicetype').innerHTML;
      var sel_DeviceSubType = this.document.getElementById('spn_MapDeviceSubtype').innerHTML;
      var sel_LocationType = this.document.getElementById('spn_MapLocationtype').innerHTML;

      var sel_Staffdata;
      var sel_NearestStaffdata;
      var width = window.innerWidth;

      this.notifiedinfo = this.alertinfo.filter(function(e)
      {
        return e.AlertId == parseInt(sel_AlertId)
      });
      
      if (width <= 500 && this.Chk_mapnotification == 0 && sel_AlertId!="") {        
          this.Chk_mapnotification = 1;
          var Notifyitem : getNotifybyAlert =
          { 
            siteId: this.SiteId,
            authKey: localStorage.getItem("Authkey"),
            alertType: parseInt(sel_AlertType), 
            alertId: parseInt(sel_AlertId), 
            isResident: parseInt(sel_AlertResStaff), 
            deviceSubType: parseInt(sel_DeviceSubType), 
            deviceType: parseInt(sel_DeviceType),
            nLocationZone: parseInt(sel_LocationType) 
          };          
          this.homeService.getNotificationByAlert(Notifyitem).pipe(takeUntil(this._onDestroy))
            .subscribe((Staffdata: any[]) => {
              sel_Staffdata = Staffdata["apireturn"];              
              var NearestStaffitem : getNearestStaff = 
              { 
                siteId: this.SiteId, 
                authKey: localStorage.getItem("Authkey"), 
                roomId: parseInt(sel_RoomId), 
                floorId: parseInt(sel_FloorId) 
              }
              this.homeService.getNearestStaffForAlert(NearestStaffitem).pipe(takeUntil(this._onDestroy))
                .subscribe((NearestStaffdata: any[]) => {
                  sel_NearestStaffdata = NearestStaffdata;
                  var NotifyData = {
                    AlertData: this.notifiedinfo,
                    CampusId: parseInt(sel_CampusId),
                    BuildingId: parseInt(sel_BuildingId),
                    FloorId: parseInt(sel_FloorId),
                    RoomId: parseInt(sel_RoomId),
                    AlertId: parseInt(sel_AlertId),
                    AlertType: parseInt(sel_AlertType),
                    AlertResStaff: parseInt(sel_AlertResStaff),
                    DeviceType: parseInt(sel_DeviceType),
                    DeviceSubType: parseInt(sel_DeviceSubType),
                    LocationType: parseInt(sel_LocationType),
                    Staffdata: sel_Staffdata,
                    NearestStaffdata: sel_NearestStaffdata
                  }

                  let dialogRefMap = this.dialog.open(MapnotificationComponent, {
                    disableClose: true,
                    width: '450px',
                    height: '340px',
                    panelClass: 'myapp-no-padding-dialog',
                    autoFocus: false,
                    data: NotifyData
                  });

                  dialogRefMap.afterClosed().subscribe(result => {
                    this.Chk_mapnotification = 0;
                  });
                });
            });
        }      
    }
    catch (err) {
      throw new Error('home.component.ts' + ' - showmapnotification() - ' + err.message);
    }
  }
    
  showAccessCode() {
    try {
      if(!SessionCheck(this.router))
      {
          return;
      }
      let sel_CampusId = this.document.getElementById('spn_CampusId').innerHTML;
      let sel_BuildingId = this.document.getElementById('spn_BuildingId').innerHTML;
      let sel_FloorId = this.document.getElementById('spn_FloorId').innerHTML;
      let sel_RoomId = this.document.getElementById('spn_RoomId').innerHTML;
      let sel_AlertId = this.document.getElementById('spn_AlertId').innerHTML;
      let sel_ResidentId = this.document.getElementById('spn_ResidentId').innerHTML;
      
      this.ResidentId= this.SharedDetails.SharedResidentId;
      var AccessCodeData = { AccessCodeType: "SerachResident", AlertData: this.alertinfofromshared, CampusId: parseInt(sel_CampusId), BuildingId: parseInt(sel_BuildingId), FloorId: parseInt(sel_FloorId), RoomId: parseInt(sel_RoomId), AlertId: parseInt(sel_AlertId) }

      let dialogRef = this.dialog.open(AccesscodeComponent, {
        disableClose: true,
        width: '450px',
        height: '280px',
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data: AccessCodeData
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == "Confirm") {          
          if(this.SharedFloorAlertDetails != undefined)
          {
          this.MCampusId = this.SharedFloorAlertDetails.SharedFloorCampusId;
          this.MBuildingId = this.SharedFloorAlertDetails.SharedFloorBuildingId;
          this.MFloorId = this.SharedFloorAlertDetails.SharedFloorFloorId;
          this.MSubZoneId = this.SharedFloorAlertDetails.SharedFloorSubZoneId;
          this.AlertId = this.SharedFloorAlertDetails.SharedFloorAlertId;
          this.AlertStatus = this.SharedFloorAlertDetails.SharedFloorAlertStatus;

            var _SharedDetails = set_SharedDetails(this.MCampusId, this.MBuildingId, this.MFloorId, this.MSubZoneId, this.AlertId, this.AlertStatus, this.ResidentId + "-" + sel_ResidentId, this.alertSharedService);
          }
        }
      });
    }
    catch (err) {
      throw new Error('home.component.ts' + ' - showAccessCode() - ' + err.message);
    }
  }

  MapDetailsChanged() { // when floor popup slected.
    try {
      if(!SessionCheck(this.router))
      {
          return;
      }
      let element_selected = this.document.getElementById('mapselected');
      this.MMapDataDetails = element_selected.innerHTML;
      if(this.MMapDataDetails != null)
      {
        var arrMapDetails = this.MMapDataDetails.split('_');

        if (arrMapDetails.length == this.Map_array_length) {
          this.MCampusId = parseInt(arrMapDetails[0]);
          this.MBuildingId = parseInt(arrMapDetails[1]);
          this.MFloorId = parseInt(arrMapDetails[2]);
          this.MSubZoneId = parseInt(arrMapDetails[3]);
          this.AlertId = arrMapDetails[4];
          this.AlertStatus = parseInt(arrMapDetails[5]);
          this.StaffAlert = parseInt(arrMapDetails[6]);
          this.InfraAlert = parseInt(arrMapDetails[7]);
          

          var _SharedDetails = set_SharedDetails(this.MCampusId, this.MBuildingId, this.MFloorId, this.MSubZoneId, this.AlertId, this.AlertStatus, this.ResidentId, this.alertSharedService)
        }
      }
    }
    catch (err) {
      throw new Error('home.component.ts' + ' - MapDetailsChanged() - ' + err.message);
    }
  }
  CheckResidenStaff=0;
  OnMapclick(MapData) {
    try {
      if (!SessionCheck(this.router)) {
        return;
      }
      if (MapData == enumCheckResidenStaff.Resident) {
        this.CheckResidenStaff=enumCheckResidenStaff.Resident;        
        RefreshIconDetails(this.alertSharedService,enumCheckResidenStaff.Resident);

      }
      else if (MapData == enumCheckResidenStaff.Staff) {
        this.CheckResidenStaff=enumCheckResidenStaff.Staff;        
        RefreshIconDetails(this.alertSharedService,enumCheckResidenStaff.Staff)
      }
      else if (MapData == enumCheckResidenStaff.All) {
        this.CheckResidenStaff=enumCheckResidenStaff.All;        
        RefreshIconDetails(this.alertSharedService,enumCheckResidenStaff.All)
      }
      else if (MapData == enumCheckResidenStaff.None) {
        this.CheckResidenStaff=enumCheckResidenStaff.None;        
       RefreshIconDetails(this.alertSharedService,enumCheckResidenStaff.None)
      }
      else if (MapData == enumCheckResidenStaff.BuildingOutline) {
      
        RefreshIconDetails(this.alertSharedService,enumCheckResidenStaff.BuildingOutline)
      }
      else if (MapData == enumCheckResidenStaff.ApproximateOutline) {
      
        RefreshIconDetails(this.alertSharedService,enumCheckResidenStaff.ApproximateOutline)
      }
      else if (MapData == enumCheckResidenStaff.BothOutline) {
      
        RefreshIconDetails(this.alertSharedService,enumCheckResidenStaff.BothOutline)
      }
      else {    
   
        var item = { SiteId: this.SiteId, MapDetails: MapData };
        this.getMapDetails(item)
      }

    }
    catch (err) {
      throw new Error('home.component.ts' + ' - OnMapclick() - ' + err.message);
    }
  }

  getMapDetails(MapDetails): void {    
    try {
     
      if (MapDetails.MapDetails.SelectedMapInfo.length > 0) {        
        var arrMapDetails = []
        arrMapDetails = MapDetails.MapDetails.SelectedMapInfo;
        this.CampusFulldetails = MapDetails.MapDetails;
        this.MCampusId = parseInt(arrMapDetails[0]);
        this.MBuildingId = parseInt(arrMapDetails[1]);
        this.MFloorId = parseInt(arrMapDetails[2]);
        this.AlertId = arrMapDetails[3];
        this.AlertStatus = parseInt(arrMapDetails[4]);
        this.ResidentId = arrMapDetails[5];

        let bNeedBuildingOutline=arrMapDetails[6];
        let bNeedApprOutline=arrMapDetails[7];
        this.MSubZoneId = arrMapDetails[8];
                
        var _SharedDetails = set_SharedDetails(this.MCampusId, this.MBuildingId, this.MFloorId, this.MSubZoneId, this.AlertId, this.AlertStatus, this.ResidentId, this.alertSharedService)
        var _SharedHomeMapDetails;
        if (arrMapDetails[2] == "0") {          
          var CampusId = arrMapDetails[0];
          var Campusinfo = groupBy(this.CampusFulldetails["Campusinfo"], 'CampusId');
          
          this.CampusImageURL = Campusinfo[CampusId][0]["FloorPlanImage"];
          this.ImageWidth = Campusinfo[CampusId][0]["ImageWidth"];
          this.ImageHeight = Campusinfo[CampusId][0]["ImageHeight"];
          this.SvgImageUrl = appsettings.CAMPUS_IMAGE_FOLDER + "/" + Campusinfo[CampusId][0]["svgFile"];
          this.ImageUrl = appsettings.CAMPUS_IMAGE_FOLDER + "/" + this.CampusImageURL;
          this.SvgInfo = Campusinfo[CampusId][0]["Campusdetail"];
          this.SpaceInfo = Campusinfo[CampusId][0]["Spacedetail"];
          this.CZoomLevel = Campusinfo[CampusId][0]["ZoomLevel"];
          this.CRotateLevel = Campusinfo[CampusId][0]["RotateLevel"];
          this.TranslateX = Campusinfo[CampusId][0]["TransformX"];
          this.TranslateY = Campusinfo[CampusId][0]["TransformY"];
          this.FloorInfo = null;       

          this.DrawMapCall(bNeedBuildingOutline,bNeedApprOutline);
        }
        else {
          ///Floor details for map
          var CampusId = arrMapDetails[0];
          var BulidingId = arrMapDetails[1];
          var FloorId = arrMapDetails[2];
          this.AlertId = "";
          this.AlertStatus = 0;
          var Campusinfo = groupBy(this.CampusFulldetails["Campusinfo"], 'CampusId');
          var buildinginfo = groupBy(Campusinfo[CampusId][0]["Campusdetail"], 'buildingid');
          var floorinfo = groupBy(buildinginfo[BulidingId][0]["floors"], 'floorid');

          this.FloorImageURL = floorinfo[FloorId][0].FloorPlanImage;
          this.ImageWidth = floorinfo[FloorId][0].ImageWidth;
          this.ImageHeight = floorinfo[FloorId][0].ImageHeight;
          this.CZoomLevel = floorinfo[FloorId][0].FZoomLevel;
          this.CRotateLevel = floorinfo[FloorId][0].FRotateLevel;
          this.ImageUrl = appsettings.FLOOR_IMAGE_FOLDER + "/" + this.FloorImageURL;
          this.SvgInfo = null;
          this.SpaceInfo = null;
          this.FloorInfo = null;
          this.TranslateX = floorinfo[FloorId][0].FTranslateX;
          this.TranslateY = floorinfo[FloorId][0].FTranslateY;
          let voiceLicense = localStorage.getItem("voice_license");
          var data :getDeviceDetailsReq = 
            { siteId: this.SiteId,
              authKey: localStorage.getItem("Authkey"),
              campusId:parseInt(CampusId),
              floorId: parseInt(FloorId),
              status: "3",
              devicetype: 0,
              device: 0, 
              spaceId: 0,
              isIndoor:1,
              isNeedRoomonly:0,
              isNeedIntercom:parseInt(voiceLicense) };

          this.selectFloorInfoFull(data,bNeedBuildingOutline,bNeedApprOutline);
        }
      }
    }
    catch (err) {
      throw new Error('home.component.ts' + ' - getMapDetails() - ' + err.message);
    }
  }

  //load the image for map whether Campus or floor image
  LoadMapImage(ImageUrl) {
    try {      
      ///Map width and height
      let imgwh = map_widthandheight(this.ImageWidth, this.ImageHeight);
      var imgwidth = imgwh.ImageWidth;
      var imgheight = imgwh.ImageHeight;
      this.imgheight = imgheight;
      this.imgwidth = imgwidth;      
      let element = this.document.getElementById('map');
      let BackgroundIMG="Centrak";
      var map = map_creation(ImageUrl, imgwidth, imgheight, false, BackgroundIMG, this.CZoomLevel, this.CRotateLevel, element.offsetWidth, element.offsetHeight,this.TranslateX,this.TranslateY, 'map', [], 0);
      
      var translateX = this.TranslateX;
      var translateY = this.TranslateY;

      translateX = translateX / 130;
      translateY = translateY / 135;

      translateX = translateX * imgwidth;
      translateY = translateY * imgheight;

      var MapCenter = map.getView().getCenter();
     
      MapCenter[0] -= translateX;
      MapCenter[1] += translateY;
      map.on('moveend', function (e) {
        getCheckInExtent(e,map,imgwidth,imgheight,MapCenter);
      });
      return [map];
    }
    catch (err) {
      throw new Error('home.component.ts' + ' - LoadMapImage() - ' + err.message);
    }
  }

  DrawMapCall(bNeedBuildingOutline,bNeedApprOutline) {
    try {
      //Map Empty
      let element = this.document.getElementById('map');
      
      element.innerHTML = '';
      let map_SharedDetails = this.SharedDetails;
      let map_sharedService = this.alertSharedService;
      let map_CheckAlertData = this.CheckAlertData;

      var arrBuildingId = [];
      var arrAlertBuildingId = [];
      var arrRoomId = [];
      var arrAlertRoomId = [];

      var SharedResidentId ="";

      if (map_SharedDetails!=undefined && map_SharedDetails.SharedResidentId !=undefined)
          SharedResidentId = map_SharedDetails.SharedResidentId.toString();

      var SharedSubZoneId=0;
      if (map_SharedDetails!=undefined && map_SharedDetails.SharedSubZoneId !=undefined)
        SharedSubZoneId =map_SharedDetails.SharedSubZoneId;

      var selectedResidentId;
      if (SharedResidentId != null)
      {
         selectedResidentId = SharedResidentId.split('-');
      }
      
      this.SharedDetails.SharedResidentId = selectedResidentId[0];
      this.ResidentId = selectedResidentId[0];
      var ImagePath = this.Map_image_path;
      //Search Alert Icon style
      var searchalerticonStyledesc = searchalerticonstyle(1,this.Map_image_path);

      // Polygons style
      var labelStyle = label_Polygon(1);
      var fillcolorStyle = fillcolor_style_Home(fillcolorPolygon.Incomplete);
      //var fillcolorStyle = fillcolor_style(fillcolorPolygon.Incomplete);
      var style = [labelStyle];

      var map;
      [map] = this.LoadMapImage(this.ImageUrl);

      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////               POP UP              /////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      var popup = new Popup({ insertFirst: false });
      popup.autoPan = true;
      popup.autoPanAnimation={duration: 250};
      var mapHeight = this.imgheight;
      var map_length = this.Map_array_length;
      var image_path = this.Map_image_path;
      //Popup on click over feature
      var alertdatainfo = this.alertinfo;
      var residentimgurl = this.residentImgUrl;
      var staffImgUrl = this.staffImgUrl;
      var MCampusId = this.MCampusId;
      var MFloorId = this.MFloorId;
      var MSubZoneId = this.MSubZoneId;
      var AlertId = this.AlertId;
      

      // Add a click event handler to the popup DOM element which we will use to
      // capture the user clicking on a link within the popup with an "action" data attribute
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////               Select option            /////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      var select = null; // ref to currently selected interaction

      var selectstyle = new Array();

      var AlertIconDetails;

      if (this.AlertStatus != alert_raisedon.resident_search) {
        if (JSON.stringify(alertdatainfo) != undefined) {
          if (alertdatainfo.length > 0) {
            if (map_SharedDetails != undefined) {
              AlertIconDetails = alertdatainfo.filter(function (e1) {
                return e1.AlertId == map_SharedDetails.SharedAlertId;
              });
            }
            if (AlertIconDetails != undefined) {
              if (AlertIconDetails.length > 0) {
                selectstyle = [alerticonstyle(1,ImagePath), alerticonred(1,ImagePath, AlertIconDetails[0].iconStyleImg)];
              }
            }
          }
        }
      }
      else {
        selectstyle = [searchalerticonStyledesc];
      }

      // select interaction working on "click"
      var selectClick = new Select({
        condition: click,
        style: selectstyle
      });

      var changeInteraction = function () {
        if (select !== null) {
          map.removeInteraction(select);
        }

        select = selectClick;
        if (select !== null) {
          map.addInteraction(select);
          select.on('select', function (e) {
            select.getFeatures().clear();
          });
        }
      };

      changeInteraction();
   

      maponclicked(map, popup, select, map_sharedService, map_length, alertdatainfo, residentimgurl, staffImgUrl, image_path, this.router,this.dialog);     
      /// marker array ///
      var arrmarker = [];
      var arrmarkerName = [];
      var arrdevicemarker = [];

      var vectorLayer;
      var geojsonObject;
      var geoFloorjsonObject;

    

      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////            Outdoor   Map Space Json load              /////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      if (this.SpaceInfo != null && bNeedApprOutline ==1) {
        /// Geo Feature Collection ///
        geojsonObject = get_geojsonObject_campus(enumRequestFrom.home_page);
        geojsonObject.type = "FeatureCollection";
        geojsonObject.features.length = 0;

        if (this.SpaceInfo.length > 0) {
          var arrSpaceInfo = this.SpaceInfo;
          for (var nSpace = 0; nSpace <= arrSpaceInfo.length - 1; nSpace++) {
            arrBuildingId[arrBuildingId.length] = arrSpaceInfo[nSpace].spaceId + "_1";           
            LoadBuildingSvg(map_sharedService, arrSpaceInfo[nSpace], MCampusId, alertdatainfo, mapHeight, geojsonObject, arrmarker, arrmarkerName, 1);
          }
          var _map = map;
          this.alertSharedService.changedMapDetails(_map);

          var space_fillcolorStyle = fillcolor_style_Home(fillcolorPolygon.Completed);
          
          
           AddBuildingLayer(map, geojsonObject, space_fillcolorStyle, arrmarker, ImagePath, arrmarkerName, labelStyle, style, map_sharedService, this.MCampusId, this.pollingData, map_SharedDetails, map_CheckAlertData, alertdatainfo, this.residentImgUrl, this.staffImgUrl, popup, select, arrSpaceInfo, searchalerticonStyledesc, mapHeight, map_length, arrBuildingId, arrAlertBuildingId,this.router,1);

          map_sharedService.currentsharedMapDetails().pipe(takeUntil(this._onDestroy)).subscribe((ShareMapDetails) => { map = ShareMapDetails });
          map_sharedService.currentsharedMapVectorLayer().pipe(takeUntil(this._onDestroy)).subscribe((ShareMapVectorLayer) => { vectorLayer = ShareMapVectorLayer });

          ShowPopupManual(map_sharedService, this.AlertId, this.AlertStatus, this.residentImgUrl, this.staffImgUrl, map, select, vectorLayer, alertdatainfo, arrSpaceInfo, searchalerticonStyledesc, mapHeight, map_length, ImagePath, map_SharedDetails.SharedResidentId, map_SharedDetails.SharedBuildingId, this.router);

          map_sharedService.currentsharedMapDetails().pipe(takeUntil(this._onDestroy)).subscribe((ShareMapDetails) => { map = ShareMapDetails });
          map_sharedService.currentsharedMapVectorLayer().pipe(takeUntil(this._onDestroy)).subscribe((ShareMapVectorLayer) => { vectorLayer = ShareMapVectorLayer });
        }
      }

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////               Map Svg Json load              /////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      if (this.SvgInfo != null && bNeedBuildingOutline ==1) {
        /// Geo Feature Collection ///
        geojsonObject = get_geojsonObject_campus(enumRequestFrom.home_page);
        geojsonObject.type = "FeatureCollection";
        var arrgeojsonObject = geojsonObject.features; // empty Object
        geojsonObject.features.length = 0;

        if (this.SvgInfo.length > 0) {
          var arrSvgInfo = this.SvgInfo;
          for (var nsvg = 0; nsvg <= arrSvgInfo.length - 1; nsvg++) {
            arrBuildingId[arrBuildingId.length] = arrSvgInfo[nsvg].buildingid;
            if (arrSvgInfo[nsvg].AlertBuildingcnt > 0)
              arrAlertBuildingId[arrAlertBuildingId.length] = arrSvgInfo[nsvg].buildingid;
            LoadBuildingSvg(map_sharedService, arrSvgInfo[nsvg], MCampusId, alertdatainfo, mapHeight, geojsonObject, arrmarker, arrmarkerName, 0);
          }
          var _map = map;
          this.alertSharedService.changedMapDetails(_map);

           AddBuildingLayer(map, geojsonObject, fillcolorStyle, arrmarker, ImagePath, arrmarkerName, labelStyle, style, map_sharedService, this.MCampusId, this.pollingData, map_SharedDetails, map_CheckAlertData, alertdatainfo, this.residentImgUrl, this.staffImgUrl, popup, select, arrSvgInfo, searchalerticonStyledesc, mapHeight, map_length, arrBuildingId, arrAlertBuildingId,this.router,0);

          map_sharedService.currentsharedMapDetails().pipe(takeUntil(this._onDestroy)).subscribe((ShareMapDetails) => { map = ShareMapDetails });
          map_sharedService.currentsharedMapVectorLayer().pipe(takeUntil(this._onDestroy)).subscribe((ShareMapVectorLayer) => { vectorLayer = ShareMapVectorLayer });

          ShowPopupManual(map_sharedService, this.AlertId, this.AlertStatus, this.residentImgUrl, this.staffImgUrl, map, select, vectorLayer, alertdatainfo, arrSvgInfo, searchalerticonStyledesc, mapHeight, map_length, ImagePath, map_SharedDetails.SharedResidentId, map_SharedDetails.SharedBuildingId, this.router);

          map_sharedService.currentsharedMapDetails().pipe(takeUntil(this._onDestroy)).subscribe((ShareMapDetails) => { map = ShareMapDetails });
          map_sharedService.currentsharedMapVectorLayer().pipe(takeUntil(this._onDestroy)).subscribe((ShareMapVectorLayer) => { vectorLayer = ShareMapVectorLayer });
        }
      }
      
      //https://openlayers.org/en/latest/examples/geojson.html
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////               Floor Svg Json load              /////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      if (this.FloorInfo != null) {
        /// Geo Feature Collection ///
        geoFloorjsonObject = get_geojsonObject_floor(enumRequestFrom.home_page);
        geoFloorjsonObject.type = "FeatureCollection";
        var arrgeoFloorjsonObject = geoFloorjsonObject.features; // empty Object
        geoFloorjsonObject.features.length = 0;

        //if (this.FloorInfo.length > 0) {
        var arrFloorInfo = this.FloorInfo;
        var IsDeviceEmpty = 0;
        
        //Load the polyline Start
        
        var arr_arrpolypoint = new Array();
        var arr_arrIsDuplicate = new Array();
        var arr_arrunitid = new Array();
        var arr_arrpolypointData = new Array();
    
        for (var ninfo = 0; ninfo <= arrFloorInfo.length - 1; ninfo++) {
          if (arrFloorInfo[ninfo].polyline != undefined) {
            var indexval = arr_arrpolypoint.indexOf(arrFloorInfo[ninfo].polyline);
            var unitIdindexval = arr_arrunitid.indexOf(arrFloorInfo[ninfo].UnitId);
            if (indexval==-1 || unitIdindexval==-1) {
              var len = arr_arrpolypoint.length;
              arr_arrpolypointData[len] = { 'multiUnitId':'','multiDataId': '', 'multiDeviceId': '', 'multiFilterDeviceTypeId': '', 'multiFilterDeviceType': '' };
              arr_arrpolypointData[len].multiUnitId = arrFloorInfo[ninfo].UnitId;
              arr_arrpolypointData[len].multiDataId = arrFloorInfo[ninfo].DataId;
              arr_arrpolypointData[len].multiDeviceId = arrFloorInfo[ninfo].DeviceId;
              arr_arrpolypointData[len].multiFilterDeviceTypeId = arrFloorInfo[ninfo].FilterDeviceTypeId;
              arr_arrpolypointData[len].multiFilterDeviceType = arrFloorInfo[ninfo].FilterDeviceType;
              arr_arrpolypoint[len] = arrFloorInfo[ninfo].polyline;
              arr_arrIsDuplicate[len] = arrFloorInfo[ninfo].isDuplicate;
              arr_arrunitid[len] = arrFloorInfo[ninfo].UnitId;
            }
            else if(indexval!=-1){
              var unitIdindexval = arr_arrunitid.indexOf(arrFloorInfo[ninfo].UnitId);
              arr_arrpolypointData[unitIdindexval].multiUnitId += "," + arrFloorInfo[ninfo].UnitId;
              arr_arrpolypointData[unitIdindexval].multiDataId += "," + arrFloorInfo[ninfo].DataId;
              arr_arrpolypointData[unitIdindexval].multiDeviceId += "," + arrFloorInfo[ninfo].DeviceId;
              arr_arrpolypointData[unitIdindexval].multiFilterDeviceTypeId += "," + arrFloorInfo[ninfo].FilterDeviceTypeId;
              arr_arrpolypointData[unitIdindexval].multiFilterDeviceType += "," + arrFloorInfo[ninfo].FilterDeviceType;          
            }
            else if(unitIdindexval!=-1){
              var unitIdindexval = arr_arrunitid.indexOf(arrFloorInfo[ninfo].UnitId);
              arr_arrpolypointData[unitIdindexval].multiUnitId += "," + arrFloorInfo[ninfo].UnitId;
              arr_arrpolypointData[unitIdindexval].multiDataId += "," + arrFloorInfo[ninfo].DataId;
              arr_arrpolypointData[unitIdindexval].multiDeviceId += "," + arrFloorInfo[ninfo].DeviceId;
              arr_arrpolypointData[unitIdindexval].multiFilterDeviceTypeId += "," + arrFloorInfo[ninfo].FilterDeviceTypeId;
              arr_arrpolypointData[unitIdindexval].multiFilterDeviceType += "," + arrFloorInfo[ninfo].FilterDeviceType;          
            }
          }
        }
        arr_arrpolypoint = new Array();
        arr_arrIsDuplicate = new Array();
        arr_arrunitid = new Array();
       
        for (var ninfo = 0; ninfo <= arrFloorInfo.length - 1; ninfo++) {
        
              var UnitId = arrFloorInfo[ninfo].UnitId;
              var DataId = arrFloorInfo[ninfo].DataId;
              var DeviceId = arrFloorInfo[ninfo].DeviceId;
              var DeviceName = arrFloorInfo[ninfo].DeviceName;
              var RoomName = arrFloorInfo[ninfo].RoomName;
              var DeviceX = arrFloorInfo[ninfo].DeviceX;
              var DeviceY = arrFloorInfo[ninfo].DeviceY;
              var MacId = arrFloorInfo[ninfo].MacId;
              var unitName = arrFloorInfo[ninfo].UnitLocation;
              var RoomCategory = arrFloorInfo[ninfo].ResRoomCategory;
        
              var DeviceType = arrFloorInfo[ninfo].FilterDeviceTypeId;
              var DeviceTypeName = arrFloorInfo[ninfo].FilterDeviceType;
              var SubZoneId= arrFloorInfo[ninfo].SubZoneId;
              var _DeviceId = DeviceId;
              var FloorId = arrFloorInfo[ninfo].FloorId;;
        
              if (RoomCategory != "" && DeviceId>0) {
                _DeviceId = RoomCategory;
              }   
        
              var polyline = new Array();
            if (arrFloorInfo[ninfo].polyline != undefined) {
              polyline = arrFloorInfo[ninfo].polyline.split(' ');

              
              var arrpolypoint = new Array();
              /// Floor poly line ///
              for (var npoly = 0; npoly <= polyline.length - 1; npoly++) {
                arrpolypoint[npoly] = polyline[npoly].split(',');
                arrpolypoint[npoly][0] = (parseFloat(arrpolypoint[npoly][0]));
                arrpolypoint[npoly][1] = getboxFromYpos(parseFloat(arrpolypoint[npoly][1]), mapHeight);
              }

              var markerpoint: any[];
          
              markerpoint = calculatexycoordinates(polyline, mapHeight); // default inside posstion it col          

              var marker = new OlFeature({
                // Added fromLonLat
                geometry: new OlPoint(markerpoint)
              });

              var imgName = "";
              var imgScale = 0.3;

              [imgName, imgScale] = getDevicetype_image(DeviceName);


              if (DeviceX == undefined || DeviceY == undefined) //if undefine we have no image shown
              {
                imgScale = 0.0;
              }
              else if (DeviceX == "" || DeviceY == "") {
                imgScale = 0.0;
              }


              var indexval = arr_arrpolypoint.indexOf(arrFloorInfo[ninfo].polyline);
              var multi_indexval = -1;        
              var unitIdindexval = arr_arrunitid.indexOf(arrFloorInfo[ninfo].UnitId);
              if (indexval==-1 || unitIdindexval==-1) {
                arr_arrIsDuplicate[arr_arrpolypoint.length] = arrFloorInfo[ninfo].isDuplicate;
                arr_arrunitid[arr_arrpolypoint.length] = arrFloorInfo[ninfo].UnitId;
                multi_indexval = arr_arrunitid.indexOf(arrFloorInfo[ninfo].UnitId);
                arr_arrpolypoint[arr_arrpolypoint.length] = arrFloorInfo[ninfo].polyline;
              }
              else {
                multi_indexval = arr_arrunitid.indexOf(arrFloorInfo[ninfo].UnitId);
              }

              marker.set("UnitId", UnitId);
              marker.set("DataId", DataId);
              marker.set("FloorId", FloorId);
              marker.set("DeviceId", DeviceId);
              marker.set("DeviceTypeName", DeviceTypeName);
              marker.set("DeviceType", DeviceType);
              marker.set("DeviceName", DeviceName);
              marker.set("UnitName", unitName);
              marker.set("DeviceTypeId",  arrFloorInfo[ninfo].FilterDeviceTypeId);
              marker.set("MacId",  MacId);
              marker.set("RoomCategory",  RoomCategory);
              marker.set("SubZoneId",  SubZoneId);

              marker.set("MultiDataId", arr_arrpolypointData[multi_indexval].multiDataId);
              marker.set("MultiDeviceId", arr_arrpolypointData[multi_indexval].multiDeviceId);
              marker.set("MultiFilterDeviceTypeId", arr_arrpolypointData[multi_indexval].multiFilterDeviceTypeId);
              marker.set("MultiFilterDeviceType", arr_arrpolypointData[multi_indexval].multiFilterDeviceType);
              var arrdevicemarker1=[];
              arrdevicemarker1.push(marker);
              

              var bNeedtoShow=false;

              if (SharedSubZoneId>0)
              {
                if (SharedSubZoneId==SubZoneId)
                  bNeedtoShow=true;
              }
              else
                bNeedtoShow=true;

        
                if ((indexval==-1 || unitIdindexval==-1) && bNeedtoShow) {
                var unit_indexval = arr_arrunitid.indexOf(arrFloorInfo[ninfo].UnitId);
                var _multiDataId = arr_arrpolypointData[unit_indexval].multiDataId;
                var _multiDeviceId = arr_arrpolypointData[unit_indexval].multiDeviceId;
                var _multiFilterDeviceTypeId = arr_arrpolypointData[unit_indexval].multiFilterDeviceTypeId;
                var _multiFilterDeviceType = arr_arrpolypointData[unit_indexval].multiFilterDeviceType;

                var arr_multiDataId = _multiDataId != null ? _multiDataId.toString().split(',') : [];
                var arr_multiDeviceId = _multiDeviceId != null ? _multiDeviceId.toString().split(',') : [];
                var arr_multiFilterDeviceTypeId = _multiFilterDeviceTypeId != null ? _multiFilterDeviceTypeId.toString().split(',') : [];
                var arr_multiFilterDeviceType = _multiFilterDeviceType != null ?  _multiFilterDeviceType.toString().split(',') : [];

                var geoFloorjsonObject = new OlFeature({
                  geometry: new Polygon([arrpolypoint]),
                  FloorId: FloorId,
                  UnitId: UnitId.toString(),
                  RoomName: RoomName,
                  DataId: DataId,
                  MultiDataId: _multiDataId,
                  MultiDeviceId: _multiDeviceId,
                  MultiFilterDeviceTypeId: _multiFilterDeviceTypeId,
                  MultiFilterDeviceType: _multiFilterDeviceType,
                  UnitName:unitName,
                  SubZoneId:SubZoneId
                });
                
                      
                  IsDeviceEmpty=0;
                  for (var nidx=0;nidx<=arr_multiDeviceId.length;nidx++)
                  {
                      if (arr_multiDeviceId[nidx] =="0" &&
                      arr_multiFilterDeviceType[nidx] != DeviceTypeDesc.Gateway && 
                      arr_multiFilterDeviceType[nidx] != NewDeviceTypeDesc.Room)
                      {
                        IsDeviceEmpty = 1;
                      }
                  }
                
                
                if (arr_multiFilterDeviceType.length == 0) {
                  IsDeviceEmpty = -1;
                }

                if (arr_multiFilterDeviceType.indexOf(NewDeviceTypeDesc.Room) != -1  && arr_multiFilterDeviceType.length == 1) {
                  IsDeviceEmpty = -1;
                }
                
                var subzonecolor=0;
                if (SharedSubZoneId ==0 && SubZoneId>0) // if currently Zone is select we need to different subzone have different color based on order.
                  subzonecolor=arrFloorInfo[ninfo].SubZoneDisplayOrder

                var deviceStyle =fillcolor_style_Home_Space(subzonecolor);
               

              var vectorSource_geo = new OlVectorSource({ features: [geoFloorjsonObject], wrapX: false });
                var vectorLayer_geo = new OlVectorLayer({
                  source: vectorSource_geo,
                  FloorId: "Floor_" + FloorId,
                  name: "Room_" + UnitId,
                  style: deviceStyle,
                  declutter: true
                });
                map.addLayer(vectorLayer_geo);
          
              }
            }
        }
      //Load the polyline End
      

        for (var ninfo = 0; ninfo <= arrFloorInfo.length - 1; ninfo++) {
          arrFloorInfo.TranslateX = this.TranslateX;
          arrFloorInfo.TranslateY = this.TranslateY;
          
          arrFloorInfo.ImageWidth = this.ImageWidth;
          arrFloorInfo.ImageHeight = this.ImageHeight;
          var ChkFloorInfo = arrFloorInfo[ninfo];
          if (ChkFloorInfo.RoomId != undefined) {
            arrRoomId[arrRoomId.length] = ChkFloorInfo.RoomId + '_' + ChkFloorInfo.FilterDeviceTypeId;


            var getfilteredAlertData = alertdatainfo.filter(function (e1) {
              if ((e1.AlertType == enumAlertType.Pull_Cord || e1.AlertType == enumAlertType.UT)  && e1.ismobilitymode == 1) {
                if (e1.FloorId == MFloorId && e1.RoomId == ChkFloorInfo.RoomId && arrAlertRoomId.indexOf(ChkFloorInfo.RoomId + '_' + ChkFloorInfo.FilterDeviceTypeId) == -1) {
                  arrAlertRoomId[arrAlertRoomId.length] = ChkFloorInfo.RoomId + '_' + ChkFloorInfo.FilterDeviceTypeId;
                  return e1.RoomId;
                }
              }
              else if ((e1.AlertType == enumAlertType.Pull_Cord || e1.AlertType == enumAlertType.UT) && e1.ismobilitymode == 0) {
                if (e1.FloorId == MFloorId && e1.TagId == ChkFloorInfo.RoomId && arrAlertRoomId.indexOf(ChkFloorInfo.RoomId + '_' + ChkFloorInfo.FilterDeviceTypeId) == -1) {
                  arrAlertRoomId[arrAlertRoomId.length] = ChkFloorInfo.RoomId + '_' + ChkFloorInfo.FilterDeviceTypeId;
                  return e1.TagId;
                }
              }
              else {
                var _RoomId = e1.RoomId
                if (_RoomId == null || _RoomId == null || _RoomId == 0) {
                  _RoomId = e1.LastRoomId;
                }
                if (e1.FloorId == MFloorId && e1.RoomId == ChkFloorInfo.RoomId && arrAlertRoomId.indexOf(ChkFloorInfo.RoomId + '_' + ChkFloorInfo.FilterDeviceTypeId) == -1 && CheckAlertByDeviceTypeId(e1.LocationType, e1.DeviceType, ChkFloorInfo.FilterDeviceTypeId)) {
                    arrAlertRoomId[arrAlertRoomId.length] = ChkFloorInfo.RoomId + '_' + ChkFloorInfo.FilterDeviceTypeId;
                  return e1.RoomId;
                }
              }
            });
          }
          LoadFloorSvg(ChkFloorInfo, MCampusId, alertdatainfo, mapHeight, arrdevicemarker, map_sharedService, MSubZoneId);
        }
        var _map = map;
        this.alertSharedService.changedMapDetails(_map);

        AddFloorLayer(map, arrdevicemarker, ImagePath, map_sharedService, MFloorId, this.pollingData, map_SharedDetails, map_CheckAlertData, alertdatainfo, this.residentImgUrl, this.staffImgUrl, popup, select, arrFloorInfo, searchalerticonStyledesc, mapHeight, map_length, MCampusId, arrRoomId, arrAlertRoomId,this.router);

        map_sharedService.currentsharedMapDetails().pipe(takeUntil(this._onDestroy)).subscribe((ShareMapDetails) => { map = ShareMapDetails });
        map_sharedService.currentsharedMapVectorLayer().pipe(takeUntil(this._onDestroy)).subscribe((ShareMapVectorLayer) => { vectorLayer = ShareMapVectorLayer });
        
        ShowFloorPopupManual(this.SharedFloorAlertDetails, this.residentImgUrl, this.staffImgUrl, map, select, vectorLayer, alertdatainfo, arrFloorInfo, searchalerticonStyledesc, AlertId, map_SharedDetails, map_sharedService, popup, map_length, selectedResidentId[1],this.router);

        map_sharedService.currentsharedMapDetails().pipe(takeUntil(this._onDestroy)).subscribe((ShareMapDetails) => { map = ShareMapDetails });
        map_sharedService.currentsharedMapVectorLayer().pipe(takeUntil(this._onDestroy)).subscribe((ShareMapVectorLayer) => { vectorLayer = ShareMapVectorLayer });
        
        RefreshIconDetails(this.alertSharedService,this.CheckResidenStaff)
       
      }
      if (this.SvgInfo == null && this.FloorInfo == null && this.ImageUrl.length ==0 ) {
        document.getElementById("map").innerHTML = "<span style='padding-top: 20%; padding-left: 45%;display:block;font-size:16px;font-weight:bold;'> Map Not Found.</span>";
      }
    }
    catch (err) {
      throw new Error('home.component.ts' + ' - DrawMapCall() - ' + err.message);
    }
  }

  

  CloseRightNav(){  
    if(SidenavComponent.isClosed == false)
    {
        this.mainLayoutService.toggleSideNavRight.emit();
    }
    if(HomeHeaderComponent.isHomeMenuClosed == false)
    {
        this.homeService.toggleHomeMenuNav.emit();
    }    
    if(HomeHeaderComponent.visible)
      HomeHeaderComponent.visible = false;
      
    if(HomeHeaderComponent.checkmatselect == 1) 
      HomeHeaderComponent.checkmatselect = 0;
  }   

 

  clkAccepteComplete()
  {
    try
    {
      if(!SessionCheck(this.router))
      {
          return;
      }
      var AcceptedAlertId = this.document.getElementById('spn_AcceptCompleteId').innerHTML;
      var Staffid = localStorage.getItem("userid")      
      var ConfirmMessageData = {
        ConfirmMessage: "Are you sure you want to Complete this Alert?"
      }     
      let dialogRef = this.dialog.open(ConfirmMessageComponent, {
        disableClose: true,
        width: 'auto',
        height: 'auto',
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data: ConfirmMessageData
      });
      
      dialogRef.afterClosed().subscribe(result => {
        var _alertinfo = this.alertinfo;
        var AcceptedAlertDetails = _alertinfo.filter(function (e1) {
          return e1.AlertId == AcceptedAlertId && (e1.AckStatus == enumAlertAckStatus.Accepted || e1.AckStatus == enumAlertAckStatus.Presence || e1.AckStatus == enumAlertAckStatus.Caregiver_Presence || e1.AckStatus ==  enumAlertAckStatus.Caregiver_Alert_Presence);
        });   
        
      if(result == "Yes" && AcceptedAlertDetails.length > 0)
      {                
            if((<HTMLInputElement> this.document.getElementById("complete")) != null)
            {
                (<HTMLInputElement> this.document.getElementById("complete")).disabled = true;
            }
          var cancelItem : cancelAlert = 
          {
            siteId:this.SiteId, 
            authKey: localStorage.getItem("Authkey"), 
            staffId:parseInt(Staffid), 
            alertId:parseInt(AcceptedAlertId), 
            status:enumAlertStatus.Complete
          }            
          this.apiService.cancelAlert(cancelItem).pipe(takeUntil(this._onDestroy))
          .subscribe((canceledResponse: any[]) => {
              if(canceledResponse["apiReturn"] == "Success")
              {                
                generateAlertMessage(this.dialog, 'Alert completed successfully.');               
                this.thisDialogRef.close('Success');                                           
              }               
              else if (canceledResponse["apiReturn"] == "Invalid Auth Key") {
                generateAlertMessage(this.dialog, 'Invalid Auth Key.');  
                this.thisDialogRef.close("close");                
                return;
              }
              var item : getAlertData = 
              { 
                siteId: this.SiteId, 
                authKey: localStorage.getItem("Authkey"),
                dateFormat:localStorage.getItem("dateFormat").toString(),
                cancelOrCompleteSec:localStorage.getItem("PAST_ALERT_LINGER")
              }  
              this.mainLayoutService.fetchAlertData(item);
                                 
          });               
      }
    }); 
    }
    catch (err) {
      throw new Error('home.component.ts' + ' - clkAccepteComplete() - ' + err.message);
    }
  }
  ngOnDestroy() {
    CloseLocationChangeSocket();
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  
}

function createVectorLayer(sourcejsonObject, bisJSON, vectorLayerName,SpaceId?) {
  var vectorLayer = new OlVectorLayer();
  try {
    var vectorSource = get_VectorSource(sourcejsonObject, bisJSON);
    if(SpaceId)
    {
      vectorLayer = new OlVectorLayer({
        source: vectorSource,
        name: vectorLayerName,
        SpaceId: "Space_" + SpaceId,
      });
    }
    else{
    vectorLayer = new OlVectorLayer({
      source: vectorSource,
      name: vectorLayerName
    });
  }
  }
  catch (err) {
    throw new Error('home.components.ts' + ' - createVectorLayer() - ' + err.message);
  }
  return vectorLayer;
}

